webpackJsonp([162898551421021],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var forofourPage = function forofourPage(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                '404 | Page Not Found'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: '404. Sorry this page cannot be found, something went wrong or the page route doesnt exist.' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            '404'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'OOPS, SORRY WE CANT FIND THAT PAGE!'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Either something went wrong or the page route doesnt exist'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/', className: 'button' },
	                        'HOME PAGE'
	                    ),
	                    _react2.default.createElement('br', null)
	                )
	            )
	        )
	    );
	};
	
	exports.default = forofourPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-84051bb5f595e786469f.js